export default __webpack_public_path__ + "static/captain-female-42fe395ad6673e2ef55db18392adb98b.png";